import React from 'react';
import { useCaseDto } from '@anonymizePro/models';

interface UseCasesCardProps {
    useCase: useCaseDto;
}
function UseCasesCard({ useCase }: UseCasesCardProps) {
    return (
        <div className="flex min-h-[296px] max-w-[282px] flex-col items-center rounded-[24px] bg-white px-4 pt-10 text-center">
            {React.createElement(useCase.icon)}
            <p className="anonymize-p1 mb-1 mt-6 text-black-800">{useCase.title}</p>
            <p className="anonymize-p4 text-black-600">{useCase.description}</p>
        </div>
    );
}

export default UseCasesCard;
